import styled from 'styled-components';

import { pxToRem } from '../../styles';

type RootProps = {
	color?: 'green' | 'red' | 'yellow' | 'orange' | 'gray';
}

const getBgColor = (colorName: string) => {
	const map = {
		'green': '#26d06d',
		'red': 'rgb(255, 59, 72)',
		'yellow': '#FFEB3B',
		'orange': 'rgb(255, 204, 1)',
		'gray': 'rgb(229, 231, 233)'
	};

	return map[colorName];
};

const getColor = (colorName: string) => {
	const map = {
		'green': '#fff',
		'red': '#fff',
		'yellow': 'rgba(0, 0, 0, 0.6)',
		'orange': 'rgba(0, 0, 0, 0.6)',
		'gray': 'rgba(0, 0, 0, 0.6)'
	};

	return map[colorName];
};

const Root = styled.span<RootProps>`
	display: inline-flex;
	padding: 4px 15px;
	border-radius: 2px;
	font-size: ${pxToRem(10)};
	font-weight: 500;
	text-transform: uppercase;
	letter-spacing: 0.3px;

	${p => p.color && `
		color: ${getColor(p.color)};
		background-color: ${getBgColor(p.color)};
	`}
`;

export {
	Root
}